import ru from './ru.json';
import en from './en.json';

export default {
  ru,
  en
};
